// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:12+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fa013d1fb1c796f27c6d200a192d0a96
//    Signature:      eyJpdiI6InZqTmpDUEZKa3hcL0JvbFlNdjRIVTZBPT0iLCJ2YWx1ZSI6InNaczF2ZW0xbEhWSDN1U0NsVGRZbU9BbENubWdKWWdCWHhHQndHZHlMdEpOWit4TGhTR1pyQ1VqUGhyYUtvMitQTW4zM0lYMk05RmZEU2VOazNPQzBTQThlTGtYWEhKZlBVNlQ1UEc5RjFDMHgreUViTTMrekk1cGt3cUxMSzAxU2NOTjBndmFWT3c0b1wvVjhhN08yTWpDRGxwanRrT3hhdTVuTW9tNGxYMXhOc2dZUFlrSHFuRlZHanpWWFpzdnJ4bnlGdjljRjlsTjBKazJjZnphYWp3ekI0d1VYZGtzU0cwSGVsdXo1c3hpeWNIZ0RSVW9rUFBwQTVmUE1ibVRpbE5KeU8wVG1oVWJmVFlkU0xId05HMnFoeVRQclFtdHBrXC9SMVlRTXQ4KzRYRmtWS2dPNlFneHI2enZ4WEV2WDBDNUVMVEFVejM1SFVIQ0JFbUkwKzBWWlwvSkR5dzlad0luOGNhTHk1OWxDcTByS0V1QnBPSnZPRVhKSVJER0N0OE5FN2psbGVTbE50eFpnWlNMWHZxR1E9PSIsIm1hYyI6ImQ4YTIyNzc3NWRlYWY4NmE4OTQyZDUxZWEyZjA5N2IzZjYyZDIzYzQzMjkxYjhmNzliY2Y1NzgwYjNkNGVlMDUifQ==
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
